import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './alert.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import DoNotShowInProduction from 'app/shared/components/do-not-show-in-production/do-not-show-in-production.component';

export const AlertDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const alertEntity = useAppSelector(state => state.alert.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="alertDetailsHeading">
          <Translate contentKey="fleetSenseApp.alert.detail.title">Alert</Translate>
        </h2>
        <dl className="jh-entity-details">
          <DoNotShowInProduction>
            <dt>
              <span id="id">
                <Translate contentKey="global.field.id">ID</Translate>
              </span>
            </dt>
            <dd>{alertEntity.id}</dd>
          </DoNotShowInProduction>
          <dt>
            <span id="name">
              <Translate contentKey="fleetSenseApp.alert.name">Name</Translate>
            </span>
          </dt>
          <dd>{alertEntity.name}</dd>
          <dt>
            <span id="alertType">
              <Translate contentKey="fleetSenseApp.alert.alertType">Alert Type</Translate>
            </span>
          </dt>
          <dd>{alertEntity.alertType}</dd>
          <dt>
            <span id="alertOperator">
              <Translate contentKey="fleetSenseApp.alert.alertOperator">Alert Operator</Translate>
            </span>
          </dt>
          <dd>{alertEntity.alertOperator}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="fleetSenseApp.alert.value">Value</Translate>
            </span>
          </dt>
          <dd>{alertEntity.value}</dd>
          <dt>
            <span id="valueInRangeMin">
              <Translate contentKey="fleetSenseApp.alert.valueInRangeMin">Value In Range Min</Translate>
            </span>
          </dt>
          <dd>{alertEntity.valueInRangeMin}</dd>
          <dt>
            <span id="valueInRangeMax">
              <Translate contentKey="fleetSenseApp.alert.valueInRangeMax">Value In Range Max</Translate>
            </span>
          </dt>
          <dd>{alertEntity.valueInRangeMax}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.alert.sensor">Sensor</Translate>
          </dt>
          <dd>{alertEntity.sensor ? alertEntity.sensor.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/alert" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/alert/${alertEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AlertDetail;
